<div>

  <button icon="pi pi-refresh" label="Atualizar" pButton (click)="carregaProcessamento($event)"></button>

  <div class="mt-3">
  <p-table [value]="processamentos" [lazy]="true" dataKey="noOrdem" (onLazyLoad)="carregaProcessamento($event)" [paginator]="true" [rows]="100" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [rowsPerPageOptions]="[20, 50, 100]" [totalRecords]="totalRecords" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"  [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}" #dt>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="processo">Processo <p-sortIcon field="processo"></p-sortIcon></th>
        <th pSortableColumn="instancia">Instância <p-sortIcon field="instancia"></p-sortIcon></th>
        <th pSortableColumn="dtSolicitacao">Dt Solicitação <p-sortIcon field="dtSolicitacao"></p-sortIcon></th>
        <th pSortableColumn="dtInicio">Inicio <p-sortIcon field="dtInicio"></p-sortIcon></th>
        <th pSortableColumn="dtFim">Fim <p-sortIcon field="dtFim"></p-sortIcon></th>
        <th pSortableColumn="usuario">Usuário <p-sortIcon field="usuario"></p-sortIcon></th>
        <th pSortableColumn="fgStatusInteg">Status <p-sortIcon field="fgStatusInteg"></p-sortIcon></th>
        <th pSortableColumn="deMensagemInteg">Mensagem <p-sortIcon field="deMensagemInteg"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-processamento>
      <tr>
        <td>{{ processamento.processo }}</td>
        <td>{{ processamento.instancia }}</td>
        <td>{{ processamento.dtSolicitacao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>{{ processamento.dtInicio | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>{{ processamento.dtFim | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>{{ processamento.usuario }}</td>
        <td>{{ processamento.fgStatusInteg }}</td>
        <td>{{ processamento.deMensagemInteg }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="21">Nenhum registro encontrado</td>
  </ng-template>
  </p-table>
</div>
</div>
